'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var anatomy = require('@chakra-ui/anatomy');
var react = require('@chakra-ui/react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _createMultiStyleConf = react.createMultiStyleConfigHelpers(anatomy.alertAnatomy.keys),
  definePartsStyle = _createMultiStyleConf.definePartsStyle,
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig;
var $fg = react.cssVar('alert-fg');
var $bg = react.cssVar('alert-bg');
var baseStyle = definePartsStyle({
  container: {
    bg: $bg.reference,
    px: 3,
    borderRadius: 'lg',
    py: 2,
    fontFamily: 'body',
    lineHeight: 'base',
    color: $fg.reference
  },
  title: {
    fontWeight: 'bold'
  },
  description: {},
  spinner: {
    color: $fg.reference,
    flexShrink: 0,
    marginEnd: 2.5,
    w: '7',
    h: '7'
  },
  icon: {
    flexShrink: 0,
    marginEnd: 2.5,
    w: 7,
    h: 7
  }
});
var variantSolid = definePartsStyle(function (props) {
  var _container;
  var c = props.colorScheme;
  return {
    container: (_container = {}, _defineProperty__default["default"](_container, $bg.variable, c === 'gray' ? 'colors.gray.700' : "colors.".concat(c, ".400")), _defineProperty__default["default"](_container, $fg.variable, "colors.white"), _defineProperty__default["default"](_container, "_dark", _defineProperty__default["default"]({}, $bg.variable, 'red')), _container)
  };
});
var variants = {
  solid: variantSolid
};
var Alert = defineMultiStyleConfig({
  baseStyle: baseStyle,
  variants: variants,
  defaultProps: {
    variant: 'solid',
    colorScheme: 'blue'
  }
});
exports["default"] = Alert;